/* eslint-disable */
import {
  MenuItemsType,
  SwapIcon,
  SwapFillIcon,
  EarnIcon,
  TrophyFillIcon,
  MoreIcon,
  TrophyIcon,
  NftFillIcon
} from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'
import { DropdownMenuItems } from '@pancakeswap/uikit/src/components/DropdownMenu/types'
import { DropdownMenuItemType } from '@pancakeswap/uikit/src/components/DropdownMenu/types'

export type ConfigMenuDropDownItemsType = DropdownMenuItems & { hideSubNav?: boolean }
export type ConfigMenuItemsType = Omit<MenuItemsType, 'items'> & { hideSubNav?: boolean } & {
  items?: ConfigMenuDropDownItemsType[]
}

const filterItemBySupportChainId = (item, chainId) => {
  return !chainId || !item.supportChainIds ? true : item.supportChainIds?.includes(chainId)
}

const config: (
  t: ContextApi['t'],
  isDark: boolean,
  languageCode?: string,
  chainId?: number,
) => ConfigMenuItemsType[] = (t, chainId) =>
    [
      {
        label: t('Swap THBM'),
        icon: SwapIcon,
        fillIcon: SwapFillIcon,
        href: '/',
        showItemsOnMobile: false,
        items: [],
      },
      {
        label: t('Exchange USDT'),
        icon: SwapIcon,
        fillIcon: SwapFillIcon,
        href: 'https://mgp-usdt.com/',
        showItemsOnMobile: false,
        type: DropdownMenuItemType.EXTERNAL_LINK,
        items: [],
      }
    ].filter((item) => filterItemBySupportChainId(item, chainId))

export default config